import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import * as _ from 'lodash';
import {ParametrizacionPorcentajeRecargaService} from "../../services/parametrizacion-porcentaje-recarga.service";

@Component({
  selector: 'app-parametrizacion-porcentaje-recarga',
  templateUrl: './parametrizacion-porcentaje-recarga.component.html',
  styleUrls: ['./parametrizacion-porcentaje-recarga.component.css']
})
export class ParametrizacionPorcentajeRecargaComponent implements OnInit {
  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  cmbTipos: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;


  constructor(
    private fb: FormBuilder,
    private _parametrizacionPorcentajeRecarga: ParametrizacionPorcentajeRecargaService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.parametrizacionPorcentajeRecarga;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.formulario = this.fb.group({
      id: [''],
      tipo: ['', [Validators.required]],
      porcentaje: ['', [Validators.required, Validators.min(1), Validators.max(100)]]
    });
    this.cmbTipos = [
      {
        id: 1,
        descripcion: "Extraordinaria"
      },
      {
        id: 2,
        descripcion: "Suplementaria"
      },
      {
        id: 3,
        descripcion: "Nocturno"
      },
    ];
    this.girdComponent();
    this.getAllPorcentajeRecarga();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAllPorcentajeRecarga() {
    this.loading = true;
    this._parametrizacionPorcentajeRecarga.getAll().subscribe((res: any) => {
      res.map(
        porcentaje => {
          const tipo = this.cmbTipos.find(tipo => tipo.descripcion === porcentaje.tipo);
          porcentaje.tipo = tipo.descripcion;
        }
      );
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'TIPO',
        field: 'tipo',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'PORCENTAJE',
        field: 'porcentaje',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarPorcentajeRecarga.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
    ];
    this.rowSelection = 'single';
  }

  editarPorcentajeRecarga({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardEditar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    const payload = this.formatData(rowData);
    this.formulario.setValue(payload);
  }

  formatData(data) {
    let rowData = _.cloneDeep(data);
    if (rowData.tipo) {
      const tipo = this.cmbTipos.find(tipo => tipo.descripcion.trim().toLowerCase() === rowData.tipo.trim().toLowerCase());
      rowData.tipo = tipo.id;
    }
    return rowData;
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarPorcentajeRecarga();
      } else {
        //this.guardarFeriado();
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = true;
    }
  }

  actualizarPorcentajeRecarga() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this._parametrizacionPorcentajeRecarga.actualizarPorcentajeRecarga(this.formulario.value),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllPorcentajeRecarga();
      this.regresar();
    });
  }

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

}
